<template>
    <div id="wrapper">
      <!-- <div v-show="learningStore.screenshotDimmed" class="screenshot-dim-overlay" /> -->
      <NuxtPage />
      <LazyGlobalDialog />
      <LazyGlobalToast />
    </div>
</template>

<script setup lang="ts">
import {useRoute, watch} from "#imports";
import { useLearningStore } from "~/store/learning/learningStore";

const route = useRoute();
const learningStore = useLearningStore();

watch(route, () => {
  window.scrollTo(0,0);
})
</script>

<style scoped>
.screenshot-dim-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 1);
  z-index: 1999;
}
</style>
